import { useSelector } from 'react-redux';
import { Redirect, useLocation, Route, RouteProps } from 'react-router-dom';

import useVerifyAuth from '@@/services/useVerifyAuth';
import { getIsLoggedIn } from '@@/store/selectors';

import SpinnerView from '../SpinnerView';

/**
 * A component that acts exactly as a react-router-dom <Route />, except it
 * only allows access to the given component if the user is logged in.
 */
export default function ProtectedRoute(routeProps: RouteProps) {
  const loginPath = '/login';
  const { pathname, search } = useLocation();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const { haveTokensLoaded } = useVerifyAuth();

  if (!haveTokensLoaded) {
    return <SpinnerView data-testid="protectedRoute_spinner" />;
  }

  // This case is only possible if a logged in user is on an authenticated
  // page and then logs out. (In cases where a logged out user attempts to hit
  // a protected route, the useVerifyAuth hook will handle the redirect to
  // the login page.)
  if (!isLoggedIn && pathname !== loginPath) {
    return <Redirect to={`${loginPath}?redirectUrl=${pathname}${search}`} />;
  }

  return <Route {...routeProps} />;
}
